module.exports = __webpack_public_path__ + "media/images/ai_voice_samples/elliot-195fb749165b060ed9bf0a2b4f079fd7.mp3";